import React, { useState } from 'react';
import Menu from '@material-ui/core/Menu';
import classNames from 'classnames';
import PropTypes from 'prop-types';
/** Material UI Components * */
import { DefaultSelectField } from '../../../../components/SelectFields'
import { DefaultTextField } from '../../../../components/TextFields';
import { MenuItem } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import {getBidWeightLabel, OPTION_LEVEL_WEIGHTED_PREFERENCE, groupByGroupSequence, getBidMode} from '../../helpers.js';
import './styles.scss';
import { RESERVE_DOWN_TO, KINDOFBID } from '../../../../data/constants';
import { useLanguage } from '../../../../context/LanguageContext';

const input_error = "Value must be between 1 and 1000";

const PreferenceRow = (props) => {
  const { labels } = useLanguage();
  const BID_NAME = labels.BID_NAME || {};
  const commonLabels = labels.commonLabels || {};
  const WEIGTH_MODE = labels.WEIGTH_MODE || {};
  const RESERVE_DOWN = labels.RESERVE_DOWN || {};
  const PREFERENCE_MENU = labels.PREFERENCE_MENU || {};

  const [error, setError] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);

  const {
    bidSession,
    score,
    scoreApplicable,
    handleMovePreference,
    bidId,
    employeeBidId,
    handleDeletePreference,
    handleDeleteCombinedPreference,
    handleNext,
    handleWeightEdit,
    totalEntries,
    description,
    displayName,
    groupName = '',
    isCombined = false,
    prefIndex,
    copyPreference
  } = props;

  const bidmode = getBidMode();

  const isNullScore = score === null && !scoreApplicable;

  const moveDown = () => {
    if (bidmode === commonLabels.PRIORITY) {
      handleMovePreference('down', score, isCombined);
    }
  };

  const moveUp = () => {
    if (bidmode === commonLabels.PRIORITY) {
      handleMovePreference('up', score, isCombined);
    }
  };

  const deletePref = () => {
    if (isCombined && groupName) handleDeleteCombinedPreference(groupName, employeeBidId);
    else handleDeletePreference(bidId, employeeBidId);
  };

  const editPref = () => {
    const bidSessionId = bidSession.currentBid.bidSessionId;
    const preference = bidSession.bidPreferences.entries.filter(
      pref => pref.bidAggregateId === bidId
    );
    handleNext({
      modalScene: 2,
      editPreference: preference[0],
      bidSessionId,
      openCombinedPreferences: false
    });
  };

  const editCombinedPref = () => {
    const bidSessionId = bidSession.currentBid.bidSessionId;
    const combined = groupByGroupSequence(bidSession.bidPreferences.entries.filter(pref => pref.groupName === groupName));

    handleNext({
      modalScene: 2,
      editPreference: combined,
      bidSessionId,
      openCombinedPreferences: true
    });
  }

  function disable() {
    document.body.style.height = '100%';
    document.body.style.overflowY = 'hidden !important';
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    disable()
  };

  const handleClose = () => setAnchorEl(null);

  const handleOptionLevel = (optionLevel) => {
    return optionLevel === RESERVE_DOWN_TO.levelAny ?
      RESERVE_DOWN_TO.levelAnyText : optionLevel - 1;
  }

  const copy = () => {
    copyPreference(employeeBidId, groupName)
  };

  const getMenuItems = () => {

  const includeMoveOptions = props.optionLevel > RESERVE_DOWN_TO.levelAny && !isNullScore;
  const includeEditOption = !isNullScore;
    let itemsText = bidmode === commonLabels.PRIORITY
      ? isCombined
        ? [
          ...(includeMoveOptions ? [
            {text: PREFERENCE_MENU.MOVE_UP, func: moveUp},
            {text: PREFERENCE_MENU.MOVE_DOWN, func: moveDown}
          ] : []),
          ...(includeEditOption ? [
            {text: PREFERENCE_MENU.EDIT, func: !groupName ? editPref : editCombinedPref}
          ] : []),
          {text: PREFERENCE_MENU.DELETE, func: deletePref},
          {text: PREFERENCE_MENU.COPY, func: copy}
        ]
        : [
          ...(includeMoveOptions ? [
            {text: PREFERENCE_MENU.MOVE_UP, func: moveUp},
            {text: PREFERENCE_MENU.MOVE_DOWN, func: moveDown}
          ] : []),
          ...(includeEditOption ? [
            {text: PREFERENCE_MENU.EDIT, func: !groupName ? editPref : editCombinedPref}
          ] : []),
          {text: PREFERENCE_MENU.DELETE, func: deletePref}
        ]
      : isCombined
        ? [
          ...(includeEditOption ? [
            {text: PREFERENCE_MENU.EDIT, func: !groupName ? editPref : editCombinedPref}
          ] : []),
          {text: PREFERENCE_MENU.DELETE, func: deletePref},
          {text: PREFERENCE_MENU.COPY, func: copy}
        ]
        : [
          ...(includeEditOption ? [
            {text: PREFERENCE_MENU.EDIT, func: !groupName ? editPref : editCombinedPref}
          ] : []),
          {text: PREFERENCE_MENU.DELETE, func: deletePref}
        ];

    // Dynamically assign sequential IDs
    itemsText = itemsText.map((item, index) => ({...item, id: index}));

    return itemsText;
  };

  const menuItemsTxt = getMenuItems();
  const menuItems = [];
  menuItemsTxt.map(option =>
    menuItems.push(
      <MenuItem key={option.id} onClick={option.func}>{option.text}</MenuItem>
    )
  );

  const menu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={() => handleClose()}
      onClick={() => handleClose()}
      disableScrollLock={false}
    >
      {menuItems }
    </Menu>);

  const onMouseLeave = () => {
    const preference = bidSession.bidPreferences.entries.filter(
      pref => pref.bidAggregateId === bidId
    );
    if (score === '') {
      handleWeightEdit(preference[0], 50, bidmode);
      setError('');
    }
  };

  const handleWeightTextField = (e, index) => {
    e.preventDefault()
    const preference = bidSession.bidPreferences.entries.filter(
      pref => pref.bidAggregateId === bidId
    );
    const value1 = parseInt(e.target.value.replace(/\D+/g, ''), 10);
      if (value1 > 0 && value1 < 1001) {
        handleWeightEdit(preference[0], value1, bidmode);
        setError('');
      } else if (value1 === '') {
        handleWeightEdit(preference[0], value1, bidmode);
        setError(input_error);
      } else if (isNaN(value1)) {
        handleWeightEdit(preference[0], '', bidmode);
        setError(input_error);
      } else {
        setError(input_error);
      }
  };

  const handleChange = (event, index, value) => {
    const preference = bidSession.bidPreferences.entries.filter(
      pref => pref.bidAggregateId === bidId
    );
    const value1 = event.target.value;
    if (value1 <= 3) {
      handleWeightEdit(preference[0], value1, bidmode);
    }
  };

  const index = props.bidSession.bidPreferences.entries.findIndex(entry => entry.bidAggregateId === props.bidId)
  const shouldDisplayWeight = index > -1 && !KINDOFBID.NO_WEIGHT_DISPLAY_BIDS.includes(props.bidSession.bidPreferences.entries[index].preferenceOptionId);
  const render = shouldDisplayWeight && !isNullScore;

  return bidmode === commonLabels.MANUAL ? (
    <div className="bid-body">
      <div>
        <div className="rectangle">
          {render && <div>
            {!Number.isInteger(props.optionLevel) && bidmode === commonLabels.AUTOMATIC ?
                Number.isInteger(props.optionLevel) && props.optionLevel !== OPTION_LEVEL_WEIGHTED_PREFERENCE ? (<p className="preferencelist-minwidth">{RESERVE_DOWN.RESERVE_DOWN_TO_LABEL} {handleOptionLevel(props.optionLevel)}</p>) :
                (
                  <div  onMouseOut={() => onMouseLeave()}>
                    <DefaultSelectField
                      value={score}
                      inputStyle={{ textAlign: 'right', width: 64 }}
                      className="auto"
                      onChange={e => handleChange(e)}
                      iconStyle={{
                        paddingleft: 0,
                        paddingRight: 0,
                        paddingTop: 0,
                        paddingBottom: 0
                      }}
                      style={{
                        paddingleft: 0,
                        paddingRight: 0,
                        paddingTop: 0,
                        paddingBottom: 0,
                        textOverflow: 'initial'
                      }}
                      id={'weight-drop-down'}
                    >
                      <MenuItem value={1}>{WEIGTH_MODE.HIGH}</MenuItem>
                      <MenuItem value={2}>{WEIGTH_MODE.MEDIUM}</MenuItem>
                      <MenuItem value={3}>{WEIGTH_MODE.LOW}</MenuItem>
                    </DefaultSelectField>
                  </div>
                )
              :
              Number.isInteger(props.optionLevel) && props.optionLevel !== OPTION_LEVEL_WEIGHTED_PREFERENCE ? (<p className="preferencelist-minwidth">{RESERVE_DOWN.RESERVE_DOWN_TO_LABEL} {handleOptionLevel(props.optionLevel)}</p>) :
              (
                <div  onMouseOut={() => onMouseLeave()}>
                  <DefaultTextField
                    id="weight"
                    className="weights"
                    value={score}
                    inputProps={{ type: 'number' }}
                    onChange={(e) => handleWeightTextField(e)}
                    disabled={props.readOnly === true}
                  />
                </div>
              )
            }
          </div> }
        </div>
        <div className="data" style={{ marginLeft: 114, marginTop: 15, display: 'flex', flexDirection: "column" }}>
          {displayName || description || `${BID_NAME} ${bidId}`}
          {error && <span style={{ color: 'red', margin: '0px', padding: '0px' }}>{error}</span>}
        </div>
      </div>
      {!props.readOnly && (
        <div style={{ alignSelf: 'end' }}>
          <button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={e => handleClick(e)}
            className='menu-button'
          >
            ...
          </button>
          {menu}
        </div>
      )}
    </div>
  ) : (
    <div className="bid-body">
      <div className="flex-row">
        {!render ? (bidmode !== commonLabels.LADDER && bidmode !== commonLabels.AUTOMATIC ? (
            <div className="spacing"></div>
          ) : null
        ) : (
          bidmode === commonLabels.NONE || (bidmode === commonLabels.PRIORITY && props.optionLevel === OPTION_LEVEL_WEIGHTED_PREFERENCE) ? (
            <div className={classNames('drag-icon-row', {hidden: props.readOnly})}><MenuIcon/></div>
          ) : null)
        }
        <div className={classNames('bid-order-wrapper', {'bid-order-wrapper-alt': !render})}>
          {!render ? (
            <div className="bid-order bg-light-gray">&nbsp;</div>
          ) : bidmode === commonLabels.AUTOMATIC ? (
            Number.isInteger(props.optionLevel) && props.optionLevel !== OPTION_LEVEL_WEIGHTED_PREFERENCE ?
              <p className="preferencelist-minwidth">{RESERVE_DOWN.RESERVE_DOWN_TO_LABEL} {handleOptionLevel(props.optionLevel)}</p>
              : (render && <div className='bid-order auto-weight-order'>{getBidWeightLabel(score)}</div>)
          ) : (
            Number.isInteger(props.optionLevel) && props.optionLevel !== OPTION_LEVEL_WEIGHTED_PREFERENCE ?
              <p className="preferencelist-minwidth">{RESERVE_DOWN.RESERVE_DOWN_TO_LABEL} {handleOptionLevel(props.optionLevel)}</p>
              : <div className="bid-order">{score}</div>
          )}
        </div>
        <div className={classNames('data', {'non-render': !render})}>{displayName || description || `${BID_NAME} ${bidId}`}</div>
      </div>
      {!props.readOnly && (
        <div>
          <button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={e => handleClick(e)}
            className='menu-button'
          >
            ...
          </button>
          {menu}
        </div>
      )}
    </div>
  );
};

PreferenceRow.defaultProps = {
  score: 0,
  scoreApplicable: true,
  description: '',
  totalEntries: 0,
  handleMovePreference: () => {},
  handleWeightEdit: () => {},
  bidSession: {},
  bidId: 0,
  employeeBidId: 0,
  handleDeletePreference: () => {},
  handleNext: () => {},
  wish: false,
  readOnly: false,
  bidmode: '',
  optionLevel: null,
  displayName: '',
  groupName: '',
  isCombined: false,
  copyPreference: () => {}
};

PreferenceRow.propTypes = {
  score: PropTypes.number.isRequired,
  scoreApplicable: PropTypes.bool,
  description: PropTypes.string,
  totalEntries: PropTypes.number,
  handleMovePreference: PropTypes.func.isRequired,
  handleWeightEdit: PropTypes.func.isRequired,
  bidSession: PropTypes.object,
  bidId: PropTypes.number,
  employeeBidId: PropTypes.number,
  handleDeletePreference: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  bidmode: PropTypes.string,
  optionLevel: PropTypes.number,
  displayName: PropTypes.string,
  groupName: PropTypes.string,
  isCombined: PropTypes.bool,
  copyPreference: PropTypes.func.isRequired
};

export default PreferenceRow;
